<script setup lang="ts">
import { Clock as ClockIcon } from '@element-plus/icons-vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

defineOptions({
    name: 'ClockWidget'
})

const now = ref(new Date())

const pad = (value: number) => value.toString().padStart(2, '0')

const timeText = computed(() => {
    const date = now.value

    return `${date.getHours()}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
})

let timer: ReturnType<typeof setInterval> | undefined

onMounted(() => {
    timer = setInterval(() => {
        now.value = new Date()
    }, 1000)
})

onBeforeUnmount(() => {
    if (timer) {
        clearInterval(timer)
    }
})
</script>

<template>
    <div class="clock-widget">
        <el-icon class="clock-widget__icon">
            <ClockIcon />
        </el-icon>
        <span class="clock-widget__time">{{ timeText }}</span>
    </div>
</template>

<style scoped lang="scss">
.clock-widget {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #717171;
    pointer-events: none;
    user-select: none;

    &__icon {
        font-size: 15px;
        color: #717171;
    }

    &__time {
        font-size: 13px;
        line-height: 1;
        font-weight: 500;
        font-variant-numeric: tabular-nums;
    }
}
</style>
